import React from "react"
import "../components/layout.css"

export default function Home() {
  return <div id="title">zmize</div>
}
